import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const ssrCookieService = inject(SsrCookieService);
  const BUSINESS_PORTAL_AUTH_COOKIE_NAME = 'MYSAPSSO2';

  let sapCookie: string | undefined;

  if (!sapCookie) {
    sapCookie = ssrCookieService.get(BUSINESS_PORTAL_AUTH_COOKIE_NAME);
  }

  const authReq = req.clone({
    setHeaders: {
      'SAPCookie': sapCookie ? encodeURIComponent(sapCookie) : ''
    }
  });

  return next(authReq);
};
